import React, { useState } from 'react';
import { Check, Plus } from 'lucide-react';
interface Integration {
  id: string;
  name: string;
  description: string;
  connected: boolean;
  logo: React.ReactNode;
}
function OutlookLogo() {
  return <div className="w-12 h-12 flex items-center justify-center" data-id="element-385">
      <svg viewBox="0 0 48 48" width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-386">
        <rect width="48" height="48" rx="8" fill="#0078D4" data-id="element-387" />
        <path d="M28 10h12v28H28V10z" fill="#50A0E0" data-id="element-388" />
        <path d="M8 14l20-4v28L8 34V14z" fill="#1565C0" data-id="element-389" />
        <ellipse cx="18" cy="24" rx="6" ry="7" fill="white" opacity="0.9" data-id="element-390" />
        <ellipse cx="18" cy="24" rx="4" ry="5" fill="#0078D4" data-id="element-391" />
        <rect x="28" y="18" width="8" height="2" rx="1" fill="white" opacity="0.8" data-id="element-392" />
        <rect x="28" y="23" width="8" height="2" rx="1" fill="white" opacity="0.8" data-id="element-393" />
        <rect x="28" y="28" width="6" height="2" rx="1" fill="white" opacity="0.8" data-id="element-394" />
      </svg>
    </div>;
}
function GmailLogo() {
  return <div className="w-12 h-12 flex items-center justify-center" data-id="element-395">
      <svg viewBox="0 0 48 48" width="48" height="48" xmlns="http://www.w3.org/2000/svg" data-id="element-396">
        <path d="M6 36V12l18 13L42 12v24H6z" fill="#F44336" data-id="element-397" />
        <path d="M6 12l18 13L42 12H6z" fill="#E53935" data-id="element-398" />
        <path d="M6 12h36l-18 13L6 12z" fill="white" opacity="0.15" data-id="element-399" />
        <rect x="6" y="12" width="36" height="24" rx="3" fill="none" stroke="#E53935" strokeWidth="0" data-id="element-400" />
        <path d="M6 14a2 2 0 012-2h32a2 2 0 012 2v20a2 2 0 01-2 2H8a2 2 0 01-2-2V14z" fill="#FAFAFA" data-id="element-401" />
        <path d="M6 14l18 12 18-12" stroke="#F44336" strokeWidth="2" fill="none" data-id="element-402" />
        <path d="M6 14l18 12 18-12V34H6V14z" fill="white" data-id="element-403" />
        <path d="M6 14l18 12 18-12" fill="none" stroke="#EA4335" strokeWidth="2.5" data-id="element-404" />
        <path d="M6 34V14l18 12 18-12v20" fill="white" data-id="element-405" />
        <path d="M6 14l18 12 18-12V34H6V14z" fill="white" data-id="element-406" />
        <path d="M6 14l18 12 18-12" stroke="#EA4335" strokeWidth="2.5" fill="none" strokeLinecap="round" data-id="element-407" />
      </svg>
    </div>;
}
function QuickBooksLogo() {
  return <div className="w-12 h-12 rounded-xl bg-[#2CA01C] flex items-center justify-center shadow-sm" data-id="element-408">
      <span className="text-white font-black text-xl tracking-tighter" data-id="element-409">QB</span>
    </div>;
}
function NetSuiteLogo() {
  return <div className="w-12 h-12 rounded-xl bg-[#F37021] flex items-center justify-center shadow-sm" data-id="element-410">
      <span className="text-white font-black text-sm tracking-tight" data-id="element-411">NS</span>
    </div>;
}
function GrandCentralLogo() {
  return <div className="w-12 h-12 rounded-xl bg-[#1E3A5F] flex items-center justify-center shadow-sm" data-id="element-412">
      <span className="text-white font-bold text-xs tracking-tight text-center leading-tight" data-id="element-413">
        GC
      </span>
    </div>;
}
function WalmartLogo() {
  return <div className="w-12 h-12 rounded-xl bg-[#0071CE] flex items-center justify-center shadow-sm" data-id="element-414">
      <span className="text-white font-black text-sm tracking-tight" data-id="element-415">WM</span>
    </div>;
}
function AmazonLogo() {
  return <div className="w-12 h-12 rounded-xl bg-[#FF9900] flex items-center justify-center shadow-sm" data-id="element-416">
      <span className="text-white font-black text-sm tracking-tight" data-id="element-417">AMZ</span>
    </div>;
}
function TargetLogo() {
  return <div className="w-12 h-12 rounded-xl bg-[#CC0000] flex items-center justify-center shadow-sm" data-id="element-418">
      <span className="text-white font-black text-sm tracking-tight" data-id="element-419">TGT</span>
    </div>;
}
function KrogerLogo() {
  return <div className="w-12 h-12 rounded-xl bg-[#004B87] flex items-center justify-center shadow-sm" data-id="element-420">
      <span className="text-white font-black text-sm tracking-tight" data-id="element-421">KR</span>
    </div>;
}
function KeHeLogo() {
  return <div className="w-12 h-12 rounded-xl bg-[#E31837] flex items-center justify-center shadow-sm" data-id="element-422">
      <span className="text-white font-black text-sm tracking-tight" data-id="element-423">KH</span>
    </div>;
}
function IntegrationCard({
  integration,
  onToggle
}: {
  integration: Integration;
  onToggle: (id: string) => void;
}) {
  return <div className="bg-white border border-slate-200 rounded-xl p-5 flex items-center justify-between shadow-sm hover:shadow-md transition-shadow" data-id="element-424">
      <div className="flex items-center gap-4" data-id="element-425">
        {integration.logo}
        <div data-id="element-426">
          <p className="font-semibold text-slate-900 text-sm" data-id="element-427">
            {integration.name}
          </p>
          <p className="text-xs text-slate-500 mt-0.5" data-id="element-428">
            {integration.description}
          </p>
        </div>
      </div>
      <button onClick={() => onToggle(integration.id)} className={`flex items-center gap-1.5 px-4 py-2 rounded-lg text-xs font-semibold transition-colors ${integration.connected ? 'bg-emerald-50 text-emerald-700 border border-emerald-200 hover:bg-emerald-100' : 'bg-slate-900 text-white hover:bg-slate-700'}`} data-id="element-429">
        {integration.connected ? <>
            <Check className="w-3.5 h-3.5" data-id="element-430" />
            Connected
          </> : <>
            <Plus className="w-3.5 h-3.5" data-id="element-431" />
            Connect
          </>}
      </button>
    </div>;
}
export function Integrations() {
  const [integrations, setIntegrations] = useState<Integration[]>([{
    id: 'outlook',
    name: 'Microsoft Outlook',
    description: 'Send and receive dispute emails via Outlook',
    connected: true,
    logo: <OutlookLogo data-id="element-432" />
  }, {
    id: 'gmail',
    name: 'Gmail',
    description: 'Send and receive dispute emails via Gmail',
    connected: false,
    logo: <GmailLogo data-id="element-433" />
  }, {
    id: 'grand-central',
    name: 'Business Central',
    description: 'Sync deduction data from Business Central ERP',
    connected: false,
    logo: <GrandCentralLogo data-id="element-434" />
  }, {
    id: 'quickbooks',
    name: 'QuickBooks Online',
    description: 'Sync invoices and payment records from QBO',
    connected: false,
    logo: <QuickBooksLogo data-id="element-435" />
  }, {
    id: 'netsuite',
    name: 'NetSuite',
    description: 'Connect your NetSuite ERP for real-time data sync',
    connected: false,
    logo: <NetSuiteLogo data-id="element-436" />
  }, {
    id: 'walmart',
    name: 'Walmart',
    description: 'Submit and track deduction disputes via Walmart Supplier Portal',
    connected: false,
    logo: <WalmartLogo data-id="element-437" />
  }, {
    id: 'amazon',
    name: 'Amazon',
    description: 'Manage shortages and chargebacks through Amazon Vendor Central',
    connected: false,
    logo: <AmazonLogo data-id="element-438" />
  }, {
    id: 'target',
    name: 'Target',
    description: 'Connect to Target Partners Online to resolve deduction disputes',
    connected: false,
    logo: <TargetLogo data-id="element-439" />
  }, {
    id: 'kroger',
    name: 'Kroger',
    description: 'Sync dispute data with Kroger Supplier Hub for faster resolution',
    connected: false,
    logo: <KrogerLogo data-id="element-440" />
  }, {
    id: 'kehe',
    name: 'KeHE',
    description: 'Connect to KeHE Connect portal to manage deductions and claims',
    connected: false,
    logo: <KeHeLogo data-id="element-441" />
  }]);
  const toggle = (id: string) => {
    setIntegrations(prev => prev.map(i => i.id === id ? {
      ...i,
      connected: !i.connected
    } : i));
  };
  const emailIntegrations = integrations.filter(i => ['outlook', 'gmail'].includes(i.id));
  const erpIntegrations = integrations.filter(i => ['grand-central', 'quickbooks', 'netsuite'].includes(i.id));
  const retailerIntegrations = integrations.filter(i => ['walmart', 'amazon', 'target', 'kroger', 'kehe'].includes(i.id));
  return <div className="space-y-8" data-id="element-442">
      <div data-id="element-443">
        <h2 className="text-2xl font-bold text-slate-900 tracking-tight" data-id="element-444">
          Integrations
        </h2>
        <p className="text-slate-500 mt-1" data-id="element-445">
          Connect your tools to automate dispute workflows.
        </p>
      </div>

      {/* Email */}
      <div data-id="element-446">
        <div className="flex items-center gap-2 mb-4" data-id="element-447">
          <h3 className="text-sm font-semibold text-slate-700 uppercase tracking-wider" data-id="element-448">
            Email
          </h3>
          <div className="flex-1 h-px bg-slate-200" data-id="element-449" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-450">
          {emailIntegrations.map(integration => <IntegrationCard key={integration.id} integration={integration} onToggle={toggle} data-id="element-451" />)}
        </div>
      </div>

      {/* ERP */}
      <div data-id="element-452">
        <div className="flex items-center gap-2 mb-4" data-id="element-453">
          <h3 className="text-sm font-semibold text-slate-700 uppercase tracking-wider" data-id="element-454">
            ERP
          </h3>
          <div className="flex-1 h-px bg-slate-200" data-id="element-455" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-456">
          {erpIntegrations.map(integration => <IntegrationCard key={integration.id} integration={integration} onToggle={toggle} data-id="element-457" />)}
        </div>
      </div>

      {/* Retailer Portal */}
      <div data-id="element-458">
        <div className="flex items-center gap-2 mb-4" data-id="element-459">
          <h3 className="text-sm font-semibold text-slate-700 uppercase tracking-wider" data-id="element-460">
            Retailer Portal
          </h3>
          <div className="flex-1 h-px bg-slate-200" data-id="element-461" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-462">
          {retailerIntegrations.map(integration => <IntegrationCard key={integration.id} integration={integration} onToggle={toggle} data-id="element-463" />)}
        </div>
      </div>
    </div>;
}